module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/invoice/assets/img/invoice_icon_nomal.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/invoice/assets/img/invoice_icon_nomal.png
// module id = 1455
// module chunks = 418